import owlCarousel from '../../components/owl-carousel'
import anchorAnimated from '../../components/anchor-animated'


const init = () => {
  new owlCarousel().clients()
  new anchorAnimated().init()
}

export default init
